export interface Conference {
	date: string
	id: string
	isFuture: boolean
	name: string
}

export enum TabStatus {
	Error = 'error',
	Loaded = 'loaded',
	Loading = 'loading'
}

export interface Filters {
	[key: string]: any
}

export type FilteringTypes = "year"